import {
  Button,
  IconButton,
  ListItemButton,
  ListItemButtonProps,
  ListItemSecondaryAction,
  ListItemText
} from '@mui/material'
import { Asset } from '../types'
import { useTranslation } from 'react-i18next'
import AssetNameEditButton from './AssetNameEditButton'

export interface AssetNameListItemButtonProps extends Omit<ListItemButtonProps, 'children'> {
  asset: Asset
  editable?: boolean
  afterUpdate?: (asset: Asset) => void
}

export default function AssetNameListItemButton({
  asset,
  editable = false,
  afterUpdate,
  ...props
}: AssetNameListItemButtonProps) {
  /**
   * The translate function.
   */
  const { t } = useTranslation('asset')

  return (
    <ListItemButton {...props}>
      <ListItemText
        primary={asset.name ?? t('noName')}
        primaryTypographyProps={{
          color: asset.name ? 'inherit' : 'text.disabled'
        }}
        secondary={t('name')}
      />

      {editable && (
        <ListItemSecondaryAction>
          <AssetNameEditButton
            asset={asset}
            component={asset.name ? IconButton : Button}
            variant="outlined"
            afterUpdate={afterUpdate}
          />
        </ListItemSecondaryAction>
      )}
    </ListItemButton>
  )
}
